import Login from "../components/Login";

export default function User() {
  return <Login />;
}
